<template>
  <div>
    <div
      id="customerServiceModal"
      class="modal fade bd-example-modal-lg"
      tabindex="-1"
      role="dialog"
      aria-labelledby="exampleModalLabel"
    >
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h3 class="modal-title" id="exampleModalLabel">詳細資料</h3>
            <button
              type="button"
              class="close"
              data-dismiss="modal"
              aria-label="Close"
              @click="closeRecordModal"
            >
              <span>&times;</span>
            </button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-6 col-sm-6">
                <span class="fontSize20 title-color">來電時間：</span>
                <span class="fontSize20">{{ record.createdAt || '' }}</span>
              </div>
              <div class="col-md-6 col-sm-6">
                <span class="fontSize20 title-color">預約時間 ：</span>
                <span class="fontSize20">
                  {{ record.reservationTime || '' }}
                </span>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-md-4 col-sm-4">
                <span class="fontSize20 title-color">來電電話：</span>
                <span class="fontSize20">
                  {{ record.passengerPhone || '' }}
                </span>
              </div>
              <div class="col-md-4 col-sm-4">
                <span class="fontSize20 title-color">客服人員：</span>
                <span class="fontSize20">
                  {{ record.customerServiceName || '' }}
                </span>
              </div>
              <div class="col-md-4 col-sm-4">
                <span class="fontSize20 title-color">車輛數：</span>
                <span class="fontSize20">{{ record.cars || '' }}輛</span>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-md-6 col-sm-6">
                <span class="fontSize20 title-color">上車地點：</span>
                <span class="fontSize20">{{ record.onLocation || '' }}</span>
              </div>
              <div class="col-md-6 col-sm-6">
                <span class="fontSize20 title-color">備註：</span>
                <span class="fontSize20">{{ record.passengerNote || '' }}</span>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-md-6 col-sm-6">
                <span class="fontSize20 title-color">下車地點：</span>
                <span class="fontSize20">{{ record.offLocation || '' }}</span>
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-md-6 col-sm-6">
                <h4 class="col-md-3 hailing">黑名單：</h4>
                <input
                  type="text"
                  class="inputstyle col-md-6 fontSize16"
                  v-model="record.blackList"
                  data-designation1
                />
              </div>
            </div>
            <hr />
            <div class="row">
              <div class="col-md-2">
                <label>
                  <input
                    type="checkbox"
                    class="fontSize20"
                    v-model="isSearchTakingPassengerCar"
                    style="zoom: 150%"
                  />
                  <span class="fontSize16 hailing">預載詢(分)</span>
                </label>
              </div>
              <div class="col-md-8">
                <h4 class="col-md-3 hailing">指定叫車:</h4>

                <input
                  type="text"
                  class="inputstyle col-md-3 fontSize16"
                  v-model="designationList[0].callNumber"
                  placeholder="隊編/呼號"
                  data-designation1
                />

                <input
                  type="text"
                  class="inputstyle col-md-3 fontSize16"
                  v-model="designationList[1].callNumber"
                  placeholder="隊編/呼號"
                  data-designation2
                />

                <input
                  type="text"
                  class="inputstyle col-md-3 fontSize16"
                  v-model="designationList[2].callNumber"
                  placeholder="隊編/呼號"
                  data-designation3
                />
              </div>
            </div>
            <hr />
            <button
              type="button"
              class="btn-success btn"
              :disabled="isHailingClick"
              @click="callCar()"
              style="float: right"
            >
              自動派遣
            </button>
            <div class="row">
              <table class="table table-striped jambo_table bulk_action">
                <thead>
                  <tr class="headings fontSize16">
                    <th class="column-title word_center">序號</th>
                    <th class="column-title word_center">叫車時間</th>
                    <th class="column-title word_center">客服人員名稱</th>
                    <th class="column-title word_center">狀態</th>
                  </tr>
                </thead>
                <tbody>
                  <template v-for="(row, index) in customerServiceList">
                    <tr
                      v-if="total > 0"
                      :class="{
                        even: index % 2 == 0,
                        odd: index % 2 != 0,
                      }"
                      class="text_hailing fontSize16"
                      style="cursor: pointer"
                      :key="row.createdAt"
                    >
                      <td class="word_center">{{ index + 1 }}</td>
                      <td class="word_center">{{ row.createdAt }}</td>
                      <td class="word_center">{{ row.serviceName }}</td>
                      <td class="word_center">{{ row.result }}</td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              data-dismiss="modal"
              @click="closeRecordModal"
            >
              關閉
            </button>
          </div>
        </div>
      </div>
      <HailResultModal
        ref="hailResultModal"
        :hailingBillData="hailingBillData"
        :customerPhone="hailingBillData.passengerPhone"
        :contactPhone="contactPhone"
        :orderIDArray="orderIDArray"
        :socket="socket"
        :customerId="customerId"
        :hasSendCar="hasSendCar"
        :isServerCheckReceiveOrder="isServerCheckReceiveOrder"
        :amountOfSendOrder="amountOfSendOrder"
        :deleteMark="deleteMark"
        @beforeCancel="beforeCancelAction"
        @sendSnsAction="sendSnsAction"
        @recallHailing="recallHailingCar"
        @releaseHaveSendedOrderCondition="releaseHaveSendedOrderCondition"
        @reqDeleteOrderMark="reqDeleteOrderMark"
      />
    </div>
  </div>
</template>

<script>
import API from '@/assets/js/libs/API'
import { Notification } from 'element-ui'
import HailResultModal from '@/components/hailing/HailResultModal.vue'
import { cookies, logoutCookies } from '@/utils/cookies'
import socketUrl from '@/assets/js/libs/Socket'
import io from 'socket.io-client'
import { generateString } from '@/utils/generateString'
import BehaviorRecorder from '@/assets/js/libs/BehaviorRecorder'
import Record_behavir from '@/assets/js/libs/FirebaseAPI/RecordBill'

const record = new Record_behavir()

export default {
  components: {
    HailResultModal,
  },
  data() {
    return {
      /* 客服人員動作名單 */
      customerServiceList: [
        { createdAt: '123', serviceName: '321' },
        { result: '43' },
      ],
      nonHailBillId: '',
      orderId: '',
      start_time: '',
      end_time: '',
      isSearchTime: false,
      isSearchTakingPassengerCar: false,
      setTime: '',
      designationList: [
        { callNumber: null },
        { callNumber: null },
        { callNumber: null },
      ],
      record: {},
      total: 0,
      /* 派遣 */
      hailingBillData: '',
      passengerPhone: '',
      orderIDArray: [],
      socket: null,
      finishHailing: false,
      vehicles: 1,
      isServerCheckReceiveOrder: false,
      amountOfSendOrder: 0,
      hasSendCar: false,
      customerId: null,
      amountOfCounter: 0,
      deleteMark: '',
      isHailingClick: false,
      lastCallCarAt: 0,
    }
  },
  methods: {
    sendSnsAction(item) {
      if (
        this.contactPhone.length === 10 &&
        this.contactPhone[0] === '0' &&
        this.contactPhone[1] === '9'
      ) {
        API.post(`sns/web`, {
          phone: this.hailTaxiInfo.contact_phone,
          orderId: item.orderId,
          url: Url(),
        })
          .then((data) => {
            if (data.success) {
              return this.$msg('傳送成功')
            }
            return this.$msg('傳送失敗')
          })
          .catch((e) => {
            console.error(e)
          })
      } else {
        this.$msg('此號碼不是手機號碼')
      }
    },
    async reqServiceList(id) {
      try {
        const { result } = await API.get(`delayHail/services/${id}`)
        this.total = result.list.length
        this.customerServiceList = result.list
        result.list.map((item, idx) => {
          this.$set(this.customerServiceList, idx, item)
        })
      } catch (e) {
        console.error(e)
        throw new Error(e)
      }
    },
    async showNonHailBill(row) {
      try {
        await this.reqServiceList(row.id)
        this.record = row
        $('#customerServiceModal').modal({
          backdrop: 'static',
          keyboard: false,
        })
      } catch (e) {
        this.closeModalEvent()
        this.closeRecordModal()
        console.error(e)
      }
    },
    closeRecordModal() {
      this.designationList[0].callNumber = null
      this.designationList[1].callNumber = null
      this.designationList[2].callNumber = null
      this.$emit('closeRecordModal', '')
    },
    closeModalEvent() {
      this.reqServiceList(this.record.id)
      this.nonHailBillId = ''
    },
    _hailingOpenModal() {
      // $('#customerServiceModal').modal('hide')
      BehaviorRecorder.record('顯示提醒', '派車頁面', '打開派車視窗')
      this.$refs.hailResultModal.openModal()
      this.$refs.hailResultModal.clearHailingResultArray()
      /* this.$refs.hailResultModal.startCountTime(true) */
    },
    closeModal() {
      this.record = {}
    },
    /* 派遣用 */
    beforeCancelAction(val) {
      this.finishHailing = true
      this.orderIDArray = []
      this.$refs.hailResultModal.hailingTaxiResult(val)
    },
    callCar() {
      const now = Date.now()
      if (this.isHailingClick || now - this.lastCallCarAt < 1000) {
        return
      }
      this.isHailingClick = true
      this.lastCallCarAt = now
      setTimeout(() => {
        this.isHailingClick = false
      }, 1000)
      BehaviorRecorder.record(
        '點擊',
        '後派單',
        `自動派遣
預約時間:${this.record.reservationTime}
上車地點:${this.record.onLocation}`,
      )
      this.amountOfSendOrder++
      this.hailingBillData = ''
      this.passengerPhone = ''
      this.vehicles = this.record.cars
      const blackList = []
      if (this.record.blackList !== null) {
        const array = this.record.blackList.split(',')
        for (let i = 0; i < array.length; i++) {
          blackList.push({
            callNumber: array[i],
            teamCode: cookies.get('GladTeamCode'),
          })
        }
      }
      const info = {
        onLocation: this.record.onLocation,
        offLocation: this.record.offLocation,
        serviceList: this.record.serviceList,
        // 加入（後派單）在備註的欄位
        passenComment:
          this.record.passengerNote +
          ',||預約時間:' +
          this.record.reservationTime +
          '(後派單)',
        onLocationLat:
          this.record.onGps !== null ? this.record.onGps.coordinates[1] : null,
        onLocationLng:
          this.record.onGps !== null ? this.record.onGps.coordinates[0] : null,
        passengerPhone: this.record.passengerPhone,
        offLocationLng:
          this.record.offGps !== null
            ? this.record.offGps.coordinates[0]
            : null,
        offLocationLat:
          this.record.offGps !== null
            ? this.record.offGps.coordinates[1]
            : null,
        cars: this.vehicles,
        account: cookies.get('GladServiceNumber'),
        passenNum: this.record.userMenber,
        seatNumber: this.record.userMenber,
        callCarType: this.record.callCarType,
        payType: this.record.payType,
        taxiSort: this.record.taxiSort,
        register: 4,
        platform: 4,
        callMethod: this.record.callMethod,
        distance: this.record.distance,
        recentDriverFirst: true,
        dispatchAreaName: this.record.dispatchAreaName,
        shiftProgram: 1,
      }
      if (blackList.length !== 0) info.blackList = blackList
      this.nonHailBillId = this.record.id
      if (info.onLocationLat === null || info.onLocationLng == null) {
        alert('無經緯度，請重新到派車頁面派遣')
        return
      }
      if (this.isSearchTakingPassengerCar) {
        info.method = 'priorSearch'
        info.priorSearcharrivalTime = parseInt(this.setTime)
        console.log('=====>預載詢', info)
      }
      if (this._getDesignationDriver().length !== 0) {
        info.designationDriver = this._getDesignationDriver()
      }
      this.hailingBillData = info
      this.passengerPhone = info.passengerPhone
      /* 叫車 */
      this._HailingTaxi()
    },
    _getDesignationDriver() {
      const designationDriver = []
      for (let i = 0; i < this.designationList.length; i++) {
        if (this._isEmpty(this.designationList[i].callNumber)) continue
        designationDriver.push({
          teamCode: cookies.get('GladTeamCode'),
          callNumber: this.designationList[i].callNumber,
        })
      }
      return designationDriver
    },
    _isEmpty(val) {
      if (Array.isArray(val)) {
        return val.length === 0
      }
      return (
        !val ||
        val === null ||
        val.replace(/^\s+|\s+$/g, '') === '' ||
        val.trim() === ''
      )
      // 其實可以砍剩 !val || val.trim() === ""
    },
    recallHailingCar(value) {
      this.vehicles = value
      BehaviorRecorder.record(
        '點擊',
        '後派單',
        `再派一次(${this.vehicles}輛車)`,
      )
      setTimeout(this._HailingTaxi, 1000)
      this.finishHailing = false
    },
    async _HailingTaxi() {
      /* 不指定叫車 */
      this._nonAssginGeneralhailingTaxi(this.hailingBillData)
    },
    async reqSubmitOrder(info) {
      return API.post('staff_hail_a_taxi', info).catch((e) => {
        console.error(e)
        // 如果是 axios error，回傳 response.data，否則回傳錯誤物件
        if (e.response && e.response.data) {
          return e.response.data
        }
        return e
      })
    },
    // 若是超過65秒還未從後端得到訂單資料，改用此api取得訂單資料
    async reqOrderTimeout(mark) {
      return API.get(
        `staff_hail_a_taxi/order?staff_hail_a_taxi_mark=${mark}`,
      ).catch((e) => console.error(e))
    },
    // 若是已經取得訂單資料，多回傳此req取消訂單註記
    async reqDeleteOrderMark(mark) {
      // console.log("delete order mark", mark);
      try {
        await API.delete(
          `staff_hail_a_taxi/order_mark?staff_hail_a_taxi_mark=${mark}`,
        )
      } catch (e) {
        console.error(e)
      }
    },
    reqGetOrderId(staffHailATaxiMark, orderIdx = null) {
      let attempt = 0
      const intervalId = setInterval(async () => {
        try {
          // send the request
          const { result: orderId } = await API.get(
            `staff_hail_a_taxi/order_id?staff_hail_a_taxi_mark=${staffHailATaxiMark}`,
          )
          attempt += 1
          if (orderId) {
            this.orderIDArray.push(orderId)
            clearInterval(intervalId)
          } else if (attempt >= 4 && !orderId) {
            this.$refs.hailResultModal.stopCountTime()
            clearInterval(intervalId)
            if (orderIdx) {
              this.$alert(
                '目前系統忙碌中，請關閉視窗，重新派車',
                `無法取得第${orderIdx}張訂單的訂單編號`,
              )
            } else {
              this.$alert(
                '目前系統忙碌中，請關閉視窗，重新派車',
                '無法取得訂單編號',
              )
            }
          }
        } catch (e) {
          console.error(e)
        }
      }, 1500)
    },
    async updateDelayHailOrderStatus(payload) {
      API.post('delayHail/service', payload)
        .then(() => {
          record.postRecord({
            type: '後派單派遣',
            event: '更新後派單',
            code: cookies.get('GladTeamCode'),
            id: this.nonHailBillId,
            note: payload,
            user_name: cookies.get('GladName'),
            user_id: '',
          })
          Notification({
            title: '可以到叫車紀錄查看是否有派車。',
            type: 'success',
          })
        })
        .catch((e) => {
          console.error(e)
          Notification({
            title: '更新後派單失敗',
            type: 'error',
          })
        })
    },
    setHailResultModal(result) {
      this.hasSendCar = false
      if (this.$refs.hailResultModal) {
        this.$refs.hailResultModal.setContactPhoneInNote()
      }

      /* 更新此筆後派單在列表中的狀態 */
      this.updateDelayHailOrderStatus({
        result: result.orderStatus === '無車輛可派' ? '無車輛' : '已派遣',
        nonHailBillId: this.nonHailBillId,
        orderId: result.orderId,
      })
      /* 更新後派單視窗中的操作列表 */
      this.reqServiceList(this.record.id)
      if (this.vehicles !== 1) {
        if (
          result.orderStatus !== '無車輛可派。' &&
          this.orderIDArray.indexOf(result.orderId) !== -1
        ) {
          record.postRecord({
            type: '立即單',
            event: '後派班派遣',
            code: cookies.get('GladTeamCode'),
            id: result.orderId,
            note: '多輛車',
            user_name: cookies.get('GladName'),
            user_id: '',
          })
          this.$refs.hailResultModal.hailingTaxiResult(result)
          return
        }
        if (this.orderIDArray.indexOf(orderId) !== -1) {
          this.$refs.hailResultModal.hailingTaxiResult(result)
          return
        }
      }
      if (
        result.orderStatus !== '無車輛可派。' &&
        result.orderId === this.orderIDArray[0]
      ) {
        record.postRecord({
          type: '立即單',
          event: '後派班派遣',
          code: cookies.get('GladTeamCode'),
          id: result.orderId,
          note: '單一',
          user_name: cookies.get('GladName'),
          user_id: '',
        })
        this.$refs.hailResultModal.hailingTaxiResult(result)
        return
      }
      if (result.orderId === this.orderIDArray[0]) {
        record.postRecord({
          type: '立即單',
          event: '後派班派遣',
          code: cookies.get('GladTeamCode'),
          id: result.orderId,
          note: '單一，無車輛可派',
          user_name: cookies.get('GladName'),
          user_id: '',
        })
        this.$refs.hailResultModal.hailingTaxiResult(result)
      }
    },
    async _nonAssginGeneralhailingTaxi(info) {
      this.amountOfCounter = 0
      this._socketConnection('後派單RecordInfoModal的socket連線')
      this.orderIDArray = []
      this.socket.sendBuffer = []
      // 紀錄訂單亂數用,需要8字元
      this.deleteMark = generateString(8)
      info.staffHailATaxiMark = this.deleteMark
      this.hailingBillData = info
      /* console.log('hailingBillData', this.hailingBillData) */
      this._hailingOpenModal()
      this.isServerCheckReceiveOrder = true
      if (this.amountOfCounter === 0) {
        this.$refs.hailResultModal.startCountTime(true)
        this.amountOfCounter = 1
      }
      // multiple cars
      this.$refs.hailResultModal.setManyCarsState(this.vehicles)
      if (this.vehicles > 1) {
        await API.post('service/callcar/group', { cars: this.vehicles })
          .then((res) => {
            if (res.result === null) return
            info.groupId = res.result
          })
          .catch((e) => {
            console.error('group', e)
          })
        // 若是多台車，則須發送多次request
        const markArr = []
        for (let idx = 0; idx < this.vehicles; idx++) {
          if (idx == 0) {
            markArr.push(info.staffHailATaxiMark)
          } else {
            markArr.push(generateString(8))
          }
        }
        this.deleteMark = markArr
        for (let idx = 0; idx < this.vehicles; idx++) {
          setTimeout(async () => {
            info.staffHailATaxiMark = markArr[idx]
            this.reqGetOrderId(markArr[idx], idx + 1)
            let result
            let res = await this.reqSubmitOrder(info)

            // 檢查是否為錯誤回應
            if (res && res.error) {
              // API 回傳錯誤，直接顯示錯誤訊息
              let errorMessage = ''
              if (res.error.message && res.error.message.trim() !== '') {
                errorMessage = res.error.message
              }

              // 組合訊息內容
              let messageContent = '目前無法取得派車結果，請先到叫車紀錄查看'
              if (errorMessage) {
                messageContent += `<br/><span style="color: red;">${errorMessage}</span>`
              }

              this.$alert(
                messageContent,
                `無法取得第${idx + 1}張派車單的結果`,
                {
                  dangerouslyUseHTMLString: true,
                },
              )
              return
            }

            // 正常回應處理
            if (res && res.message && res.message.includes('timeout')) {
              const response = await this.reqOrderTimeout(markArr[idx])
              result = response.hasOwnProperty('result')
                ? response.result
                : null
            } else {
              result = res.result
            }
            if (result) {
              this.orderIDArray.push(result.orderId)
              // NOTE: 發送此request才能觸發訂單異常
              this.createRecordDriverAbnormalList(result.orderId)
              this.setHailResultModal(result)
            } else {
              // 取得 API 錯誤訊息
              let errorMessage = ''
              if (res && res.message && !res.message.includes('timeout')) {
                errorMessage = res.message
              } else if (res && typeof res === 'string') {
                errorMessage = res
              }

              // 組合訊息內容
              let messageContent = '目前無法取得派車結果，請先到叫車紀錄查看'
              if (errorMessage) {
                messageContent += `<br/><span style="color: red;">${errorMessage}</span>`
              }

              this.$alert(
                messageContent,
                `無法取得第${idx + 1}張派車單的結果`,
                {
                  dangerouslyUseHTMLString: true,
                },
              )
            }
          }, 3000 * idx)
        }
      } else {
        this.reqGetOrderId(this.deleteMark)
        let result
        let res = await this.reqSubmitOrder(info)

        // 檢查是否為錯誤回應
        if (res && res.error) {
          // API 回傳錯誤，直接顯示錯誤訊息
          let errorMessage = ''
          if (res.error.message && res.error.message.trim() !== '') {
            errorMessage = res.error.message
          }

          // 組合訊息內容
          let messageContent = '目前無法取得派車結果，請先到叫車紀錄查看'
          if (errorMessage) {
            messageContent += `<br/><span style="color: red;">${errorMessage}</span>`
          }

          this.$alert(messageContent, '無法取得派車結果', {
            dangerouslyUseHTMLString: true,
          })
          this.isHailingClick = false
          return
        }

        // 正常回應處理
        if (res && res.message && res.message.includes('timeout')) {
          const response = await this.reqOrderTimeout(this.deleteMark)
          result = response.hasOwnProperty('result') ? response.result : null
        } else {
          result = res.result
        }
        if (result) {
          this.createRecordDriverAbnormalList(result.orderId)
          this.orderIDArray.push(result.orderId)
          this.setHailResultModal(result)
          /* this.amountOfSendOrder++ */
          this.hasSendCar = true //派出時，將isLimitSendCarNumber = true
        } else {
          // 取得 API 錯誤訊息
          let errorMessage = ''
          if (res && res.message && !res.message.includes('timeout')) {
            errorMessage = res.message
          } else if (res && typeof res === 'string') {
            errorMessage = res
          }

          // 組合訊息內容
          let messageContent = '目前無法取得派車結果，請先到叫車紀錄查看'
          if (errorMessage) {
            messageContent += `<br/><span style="color: red;">${errorMessage}</span>`
          }

          this.$alert(messageContent, '無法取得派車結果', {
            dangerouslyUseHTMLString: true,
          })
        }
        this.isHailingClick = false
      }
    },
    /* async _nonAssginGeneralhailingTaxi(info) {
      this._socketConnection('後派單RecordInfoModal的socket連線')
      this.orderIDArray = []
      // 新增多車
      if (this.vehicles > 1) {
        API.post('service/callcar/group', { cars: this.vehicles })
          .then((res) => {
            if (res.result !== null) {
              let group_id = res.result
              info.group_id = group_id
              // console.log(info);
              this.socket.sendBuffer = []
              for (let i = 0; i < this.vehicles; i++) {
                setTimeout(() => {
                  this.socket.emit('SubmitOrder', info)
                }, 1000 * i)
              }
            }
          })
          .catch((err) => {
            console.log('group', err)
          })
      } else {
        this.socket.sendBuffer = []
        this.socket.emit('SubmitOrder', info)
      }
      this.hailingBillData = info
      this.$refs.hailResultModal.setManyCarsState(this.vehicles)
      this._hailingOpenModal()
    }, */
    checkTokenExpired() {
      this.socket.on('TokenValidError', (data) => {
        if (!data.success) {
          logoutCookies()
          this._closeSocket()
          this.$notify({
            title: `請重新登入`,
            message: `您的登入資訊已過期，請重新登入，以確保資料的正確性。`,
            type: 'warning',
            position: 'top-right',
            duration: 0,
          })
        }
      })
    },
    _socketConnection(event) {
      if (this.socket) {
        this.checkTokenExpired()
        return
      }
      this.socket = io.connect(`${socketUrl}`, {
        reconnectionAttempts: 3,
        reconnectionDelay: 3000,
        query: {
          token: cookies.get('user'),
          event: event,
        },
      })
      this.socket.on('connect', () => {
        this.$refs.hailResultModal.setConnectionState(true)
      })
      this.socket.on('disconnect', () => {
        this.$refs.hailResultModal.setConnectionState(false)
      })
      /* this.socket.on('SubmitOrder', (msg) => {
        BehaviorRecorder.record(
          '收到系統回覆',
          '後派單',
          `派遣結束-${
            msg.result.callNumber
              ? '接單司機' + msg.result.callNumber
              : '無車輛可派'
          }`,
        )
        this.hasSendCar = false
        let payload = {
          nonHailBillId: this.nonHailBillId,
        }
        if (this.vehicles !== 1) {
          if (
            msg.result !== '無車輛可派。' &&
            this.orderIDArray.indexOf(msg.result.orderID) !== -1
          ) {
            let recordInfo = {}
            recordInfo.type = '立即單'
            recordInfo.event = '後派班派遣'
            recordInfo.code = cookies.get('GladTeamCode')
            recordInfo.id = msg.result.orderID
            recordInfo.note = '多車'
            recordInfo.user_name = cookies.get('GladName')
            recordInfo.user_id = ''
            record.postRecord(recordInfo)
            this.$refs.hailResultModal.hailingTaxiResult(msg)
            payload.orderId = msg.result.orderID
          }
          if (this.orderIDArray.indexOf(msg.orderId) !== -1) {
            let recordInfo = {}
            recordInfo.type = '立即單'
            recordInfo.event = '後派班派遣'
            recordInfo.code = cookies.get('GladTeamCode')
            recordInfo.id = msg.result.orderID
            recordInfo.note = '多車'
            recordInfo.user_name = cookies.get('GladName')
            recordInfo.user_id = ''
            record.postRecord(recordInfo)
            this.$refs.hailResultModal.hailingTaxiResult(msg)
            payload.orderId = msg.orderId
          }
        } else {
          if (
            msg.result !== '無車輛可派。' &&
            msg.result.orderID === this.orderIDArray[0]
          ) {
            this.$refs.hailResultModal.hailingTaxiResult(msg)
            payload.orderId = msg.result.orderID
            let recordInfo = {}
            recordInfo.type = '立即單'
            recordInfo.event = '後派班派遣'
            recordInfo.code = cookies.get('GladTeamCode')
            recordInfo.id = msg.result.orderID
            recordInfo.note = '單一'
            recordInfo.user_name = cookies.get('GladName')
            recordInfo.user_id = ''
            record.postRecord(recordInfo)
          } else if (msg.orderId === this.orderIDArray[0]) {
            console.log('msg.orderId', msg.orderId)
            this.createRecordDriverAbnormalList(msg.orderId)
            this.$refs.hailResultModal.hailingTaxiResult(msg)
            payload.orderId = msg.orderId
            let recordInfo = {}
            recordInfo.type = '立即單'
            recordInfo.event = '後派班派遣'
            recordInfo.code = cookies.get('GladTeamCode')
            recordInfo.id = msg.orderId
            recordInfo.note = '單一'
            recordInfo.user_name = cookies.get('GladName')
            recordInfo.user_id = ''
            record.postRecord(recordInfo)
          }
        }
        if (msg.result === '無車輛可派。') {
          payload.result = '無車輛'
        } else {
          payload.result = '已派遣'
        }
        API.post('delayHail/service', payload)
          .then((res) => {
            let recordInfo = {}
            recordInfo.type = '後派單派遣'
            recordInfo.event = '更新後派單'
            recordInfo.code = cookies.get('GladTeamCode')
            recordInfo.id = this.nonHailBillId
            recordInfo.note = payload
            recordInfo.user_name = cookies.get('GladName')
            recordInfo.user_id = ''
            record.postRecord(recordInfo)
            alert('可以到叫車紀錄查看是否有派車。')
          })
          .catch((err) => {
            this.$msg(err)
          })
      })
      this.socket.on('GetOrderId', (msg) => {
        this.orderIDArray.push(msg.result)
        this.isServerCheckReceiveOrder = true
        if (this.amountOfCounter === 0) {
          this.$refs.hailResultModal.startCountTime(true)
          this.amountOfCounter = 1
        }
        let payload = {
          orderId: msg.result,
          nonHailBillId: this.record.id,
        }
        API.put('delayHail/updateHailingId', payload)
          .then((res) => {
            let recordInfo = {}
            recordInfo.type = '後派單派遣'
            recordInfo.event = '更新後派單'
            recordInfo.code = cookies.get('GladTeamCode')
            recordInfo.id = payload.nonHailBillId
            recordInfo.note = payload
            recordInfo.user_name = cookies.get('GladName')
            recordInfo.user_id = ''
            record.postRecord(recordInfo)
            this.$msg('後派單修改成功')
          })
          .catch((err) => {
            console.log('group', err)
          })
      })
      this.socket.on('LineUpOrderNotify', (msg) => {
        this.$refs.hailResultModal.stopCountShiftTime()
        if (msg.success) alert('司機已看到訂單並按確認')
      }) */
      this.$refs.hailResultModal.deliverySocket(this.socket)
      this.checkTokenExpired()
    },
    createRecordDriverAbnormalList(id) {
      API.post('bill/driver/abnormal', {
        id,
        type: 'transaction',
      }).catch((e) => {
        console.error(e)
        this.$msg('網路不穩定,產生異常表失敗')
      })
    },
    _closeSocket() {
      if (!this.socket) return
      this.socket.close()
      this.socket = null
    },
    releaseHaveSendedOrderCondition() {
      this.hasSendCar = false
    },
  },
  computed: {
    contactPhone() {
      //從備註資料裡解析出聯絡電話
      const str = this.hailingBillData.passenComment
      if (!str) return ''
      // 正則表達式
      // 包含手機市話, 0開頭，1~2位數，使用-分隔，6~8位數
      // ex:
      // 手機: 0912-345678, 0912345678
      // 市話: 02-3456789, 023456789, 089-3456789
      const match = str.match(/0\d{1,2}-?\d{6,8}/g) || []
      if (match.length === 0) {
        return this.record.passengerPhone // 沒找到則回傳乘客電話
      }
      // 連絡電話固定會接在最後面 所以只取最後一個
      return match[match.length - 1].trim()
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/recordHail/RecordInfoModal.vue